import React, { memo } from 'react';
import { isNil } from 'lodash';
import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button/Button';

import { Weight, Weights } from '../../reducers/systemOfMeasurement';
import { useSystemMeasure } from './useSystemMeasure';

const weightButtons = [
    { value: Weight.KG, label: Weights[Weight.KG] },
    { value: Weight.LBS, label: Weights[Weight.LBS] },
];

export const SystemMeasure = memo(({ className, legID, weightUnits, onWeightUnitsChange, size = 'small' }) => {
    const { getClassName, handeChangeWeightUnits } = useSystemMeasure(legID, weightUnits, onWeightUnitsChange);

    if (isNil(weightUnits)) {
        return null;
    }

    return (
        <ButtonGroup className={className}>
            {weightButtons.map(({ value, label }) => (
                <Button
                    key={label}
                    size={size}
                    id={`${label}_${value}`}
                    variant={'contained'}
                    color={getClassName(value)}
                    onClick={handeChangeWeightUnits}
                >
                    {label}
                </Button>
            ))}
        </ButtonGroup>
    );
});

SystemMeasure.displayName = 'SystemMeasure';
